<template>
    <div
        class="controls"
    >
        <div class="compare">
            <div class="label">
                compare to
            </div>
            <div class="compare-input">
                <div
                    v-for="comp in model.comparisons"
                    :key="comp"
                    :class="{
                        'compare-input-option': true,
                        selected: comp === model.comparison
                    }"
                    @click="setComparison(comp)"
                >
                    {{ comp }}
                </div>
            </div>
        </div>
        <a
            class="dha-link download-pdf"
            href="javascript:void(0);"
            @click="showPDF"
        >
            <!-- <a
                class="dha-link download-pdf"
                :href="pdfHref"
            > -->
            <span class="label">Download PDF</span>
            <svg-inline
                class="download-icon"
                src="pdf_icon"
            />
        </a>
        <a
            class="dha-link share"
            href="javascript:void(0);"
            @click="share"
        >
            <span class="label">Share</span>
            <svg-inline
                class="share-icon"
                src="link_icon"
            />
            <div :class="`toast ${showToast ? 'show' : ''}`">
                {{ toastMessage }}
            </div>
        </a>
    </div>
</template>

<script>
import SvgInline from '@/components/SvgInline.vue';
import ControlsModel from '@/model/ControlsModel';

export default {
    components: {
        SvgInline
    },
    props: {
        model: {
            type: ControlsModel,
            required: true
        },
    },
    data() {
        return {
            showToast: false,
            toastMessage: 'Link copied to clipboard',
        };
    },
    computed: {
        pdfHref() {
            return `https://albertahealthycommunities.healthiertogether.ca/Frontend/community-profiles-viz/data/pdfs/CommunityProfile_${this.model.parent.geographyCode}.pdf`;
        }
    },
    methods: {
        setComparison(value) {
            this.model.comparison = value;
        },
        showPDF() {
            this.model.showPDF = true;
        },
        share() {
            this.showToast = true;
            this.toastMessage = 'Link copied to clipboard';
            if (navigator.clipboard) { // Modern browsers
                navigator.clipboard.writeText(document.location.href);
            } else if (window.clipboardData) { // IE
                window.clipboardData.setData('Text', document.location.href);
            } else {
                this.toastMessage = 'Couldn\'t copy link';
            }
            setTimeout(() => {
                this.showToast = false;
            }, 1000);
        }
    }
};
</script>

<style lang="postcss" scoped>
.controls {
    @apply flex flex-row;
}
.compare {
    @apply flex flex-row items-center;
}

.compare > * {
    @apply mx-1;
}

.compare-input {
    @apply
        flex
        flex-row
        justify-between
        rounded-full
        border-neutral-4
        bg-neutral-4
        my-1;
    height: 22px;
}

.compare-input-option {
    @apply
        font-bold
        h-full
        text-2xs
        uppercase

        text-neutral-text
        select-none
        cursor-pointer
        text-center;
    line-height: 22px;
    width: 54px;
}

.compare-input-option.selected {
    @apply
        text-white
        bg-neutral-text
        rounded-full

}


.label {
    @apply text-neutral-text font-normal whitespace-no-wrap;
}


.dha-link {
    @apply
        flex flex-row justify-center items-center
        text-neutral-3
        text-sm
        mx-2
        select-none;
    text-decoration: none !important;
}

.dha-link i {
    @apply
        font-bold
        ml-2;
    font-size: 24px !important;
}

.share {
    @apply relative;
}

.toast {
    @apply absolute text-2xs bg-neutral-text text-white px-2 py-1 whitespace-no-wrap rounded-lg opacity-0 pointer-events-none;
    top:40px;
    right:0;
}

.toast:not(.show) {
    transition: opacity 0.5s;
}

.toast.show {
    @apply opacity-75;
}

/* Keep the spacing consistent despite icon files having different dimensions */
.svg-inline-container {
    width: 40px;
}

.download-icon >>> svg {
    height: 40px;
    width: 40px;
}

.share-icon >>> svg {
    height: 25px;
    width: 25px;
}

.label { @apply text-2xs; }
.compare { @apply px-4; }

@screen md {
    .top-panel {@apply top-header; }
    .label { @apply text-xs; }
    .compare { @apply px-8; }
    .dha-link {@apply p-2;}
}
@screen mobile {
    .controls { @apply flex-col-reverse; }
    .dha-link .label {
        @apply text-sm;
    }
    .dha-link {
        @apply
            flex-row-reverse
            justify-end
            mx-0
            my-0
            select-none;
        text-decoration: none !important;
    }
    .dha-link.download-pdf {
        @apply border-b border-neutral-4;
    }
    .compare {
        @apply pt-1 mx-auto;
    }
}
</style>
